var map = {
	"./Carte-Virtuelle-APAYM-UBA.png": "0482",
	"./Carte-apaym-01.png": "f887",
	"./Carte-apaym-05.png": "ae88",
	"./Carte-apaym-06.png": "8820",
	"./visa-autre.png": "48d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21fb";